<ui-textarea #focusTextArea placeholder="Placeholder"></ui-textarea>
<ui-button text="Focus" (click)="focusTextArea.focus()"></ui-button>

<ui-textarea placeholder="Invisible on focus" [invisibleBorders]="true" style="margin-top: 2rem"></ui-textarea>

<ui-textarea id="with-max-height" placeholder="Placeholder" value="Value&#10;&#10;&#10;&#10;&#10;Value"></ui-textarea>
